import { render } from "./ViewLayout.vue?vue&type=template&id=ac281c8a&scoped=true"
import script from "./ViewLayout.vue?vue&type=script&lang=js"
export * from "./ViewLayout.vue?vue&type=script&lang=js"

import "./ViewLayout.vue?vue&type=style&index=0&id=ac281c8a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac281c8a"]])

export default __exports__